import React, { useState, useEffect } from "react";
import ButtonBase from "../buttons/ButtonBase";
import PageTitle from '../PageTitle'
import { useParams } from "react-router-dom";
import * as dayjs from 'dayjs'
import StreamDateTime from './StreamDateTime'
import VideoStreaming from "../stream/VideoStreaming";
import { $host } from "../../../../http";
import StreamFilesUpload from "./StreamFilesUpload";
import { isNull } from "lodash";

const AddStreamForm = () => {

    const serverUrl = 'wss://webinar.boost-ai.ru'
    const [accessToken, setAccessToken] = useState()
    const [streamVisible, setStreamVisible] = useState(false)
    const [createStreamVisible, setCreateStreamVisible] = useState(false)
    const [roomId, setRoomId] = useState(null)

    const { id: themeId } = useParams()

    const [theme, setTheme] = useState(null)


    const createStreamRoom = async (date) => {
        try {
            const body = new FormData()
            body.append('schedule_date', date)
            const {data} = await $host.post(`/api/teachers/webinar/create/${theme.id}`, body, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            setCreateStreamVisible(false)
            getTheme()
            console.log(data)
        } catch (e) {
            console.error(e)
        }
    }

    const enterStreamRoom = async () => {
        if (isNull(roomId)) {
            const data = new FormData()
            data.append('schedule_date', dayjs().format('YYYY-MM-DD HH:mm'))
            const {data: room} = await $host.post(`/api/teachers/webinar/create/${theme.id}`, data)
            setRoomId(await room.body.id)
        }
        const {data} = await $host.get(`/api/webinar/join/room/${roomId}`)
        setAccessToken(await data.jwt_token)
        setStreamVisible(true)
    }

    const finishStream = async () => {
        try {
            await $host.post(`/api/teachers/webinar/${roomId}/end`)
            setAccessToken(null)
            setStreamVisible(false)
        } catch (e) {
            console.error(e)
        }
    }

    const [streamInfo, setSteamInfo] = useState(null)

    const checkStreamStatus = async () => {
        try {
            const {data} = await $host.get(`/api/students/webinars/${themeId}`)
            setSteamInfo(await data)
        } catch (e) {
            console.error(e)
        }
    }
    
    const getTheme = async () => {
        try {
            const {data} = await $host.get(`/api/students/themes/${themeId}`)
            const {homework_id, webinar_room_id} = await data.theme
            const roomIdParsed = parseInt(webinar_room_id) === 0 ? null : webinar_room_id

            await setRoomId(roomIdParsed)
            
            await setTheme({
                ...(await data.theme),
                homework_id: parseInt(homework_id) === 0 ? null : homework_id,
                webinar_room_id: roomIdParsed
            })
            if(!isNull(roomIdParsed)) {
                await checkStreamStatus()
            }

        } catch(e) {
            console.error(e)
        }
    }

    useEffect(() => {
        themeId && getTheme()
    }, [themeId])

    return (
        <section className="py-10 px-6 w-full">

            <div className="px-6">
                {/* <BreadcrumbsBase items={breadcrumbs} /> */}
            </div>
            {theme && <div className="pb-16 pt-16 px-6">
                <div className="flex justify-between items-center mb-8">
                    <PageTitle >{theme.title}</PageTitle>
                    <div className="flex gap-2">
                        {theme.webinar_room_id ? <></> : 
                            <ButtonBase onClick={() => setCreateStreamVisible(true)} activestate="light">Запланировать</ButtonBase>
                        }
                        {
                            streamVisible ? 
                            <ButtonBase onClick={finishStream} activestate="danger">Завершить стрим</ButtonBase> :
                            <ButtonBase onClick={enterStreamRoom}>Запустить</ButtonBase>
                        }
                    </div>
                </div>
                <div className="mt-8 flex gap-2 items-center">
                    {streamInfo && <StreamFilesUpload webinarId={roomId} streamInfo={streamInfo} onFilesChanged={checkStreamStatus} />}
                </div>
            </div>}

            {streamVisible && accessToken && <VideoStreaming url={serverUrl} token={accessToken} updateToken={enterStreamRoom} roomId={roomId} />}

            {createStreamVisible && <StreamDateTime onSubmit={createStreamRoom} onClose={() => setCreateStreamVisible(false)} />}

        </section>
    )
}

export default AddStreamForm